export default function Services() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      icon: 'ri-user-line',
      title: 'Você escolhe seu fornecedor',
      description: 'Negocie diretamente com geradores e comercializadores',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Você define o preço',
      description: 'Contrate energia com valores personalizados e previsíveis',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Você determina as condições',
      description: 'Estabeleça contratos que atendam às necessidades específicas da sua empresa',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Você seleciona a fonte',
      description: 'Opte por energia renovável e agregue valor à sua marca',
    },
  ];

  const steps = [
    'Análise de viabilidade (que estamos oferecendo GRATUITAMENTE)',
    'Elaboração da estratégia de migração',
    'Preparação da documentação necessária',
    'Gestão do processo junto aos órgãos reguladores',
    'Implementação e acompanhamento',
  ];

  return (
    <section id="services" className="py-12 md:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-[#003366] mb-6 md:mb-8 text-center leading-tight">
          COMO FUNCIONA O MERCADO LIVRE DE ENERGIA E POR QUE ELE PODE TRANSFORMAR AS FINANÇAS DA
          SUA EMPRESA...
        </h2>
        <p className="text-center text-base md:text-lg text-[#003366] font-semibold mb-8 md:mb-12 max-w-4xl mx-auto">
          O segredo que grandes corporações usam há anos para reduzir drasticamente seus custos
          operacionais
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-5 md:p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full"
            >
              <div className="mb-3 md:mb-4 w-12 h-12 flex items-center justify-center">
                <i className={`${service.icon} text-3xl md:text-4xl text-[#003366]`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-[#003366] mb-2">{service.title}</h3>
              <p className="text-sm md:text-base text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-5 md:p-8 rounded-lg shadow-md max-w-4xl mx-auto mb-10 md:mb-16">
          <h3 className="text-lg md:text-xl font-bold text-[#003366] mb-4 md:mb-6 flex items-center">
            <i className="ri-check-line mr-2 text-xl md:text-2xl w-6 h-6 flex items-center justify-center"></i>
            O processo de migração é simples e sem riscos:
          </h3>
          <ul className="space-y-3 md:space-y-4">
            {steps.map((step, index) => (
              <li key={index} className="flex items-start">
                <div className="bg-[#003366] text-white rounded-full w-6 h-6 flex items-center justify-center text-xs md:text-sm font-bold mr-3 mt-0.5 flex-shrink-0">
                  {index + 1}
                </div>
                <span className="text-sm md:text-base text-gray-700">{step}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-center bg-[#FFF9E6] p-4 md:p-6 rounded-lg max-w-4xl mx-auto mb-8 md:mb-12">
          <p className="text-sm md:text-base font-medium text-gray-800">
            E o melhor: sua empresa não fica sem energia nem por um segundo durante a transição.
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="bg-[#FFD700] hover:bg-yellow-400 text-[#003366] font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            QUERO CONHECER MINHA ECONOMIA POTENCIAL
          </button>
        </div>
      </div>
    </section>
  );
}
